import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ActivityHistoryDto } from "src/app/model/qModel.model";
import { ApiService } from "src/app/services/api.service";
declare let $: any;

@Component({
  selector: "app-activity-history",
  templateUrl: "./activity-history.component.html",
})
export class ActivityHistoryComponent implements OnInit {
  ActivityDto: ActivityHistoryDto = new ActivityHistoryDto();
  isLoading: boolean = false;
  pageSize: number = 10;
  showDirectionLinks = true;
  pageNumber: number = 0;
  userResponse: any;
  selectedIndex: number = 0;
  getFirstIndexData: any;
  allActivity: any[] = [];
  myCount: number = 0;
  user: string = "";
  device: string = "";
  actionListArr = new Set();
  statusListArr = new Set();
  startDate: any = "";
  endDate: any = "";
  minDate: Date;
  devicesList: any[] = [];
  page?: number;
  currentPage: number = 1;
  totalItems: number = 0;
  isAccepted: boolean = false;
  deviceId: string = "";
  isChecked: boolean = false;
  checked: boolean = false;
  today = new Date();
  startMin: any;
  totalItemsTemp: number = 0;
  maxDate: any;
  showPageList: boolean = true;
  pagelength: number = 10;
  totalFIlterCount: number;
  totalFIlterCountVal: boolean = false;
  whitefilter: boolean = false;
  grayfilter: boolean = false;
  activeFilter: string = 'submit-btn bg-orgclr';
  inActivefilter: string = 'grayFilter';
  filterClass: string = '';
  filterArr: any = [];
  actionValue: any = [];
  i18NerrorCodeList: any = [];
  i18tabsList: any = [];
  errorCodeReponse: any = [];
  otherErrorCodes: any = [];
  allUserStr: string = '';
  allDeviceStr: string = '';
  userTimezone: string;
  constructor(
    private translateService: TranslateService,
    private _service: ApiService,
    private DatePipe: DatePipe
  ) {
  }


  //  Filter Array has been initialized here

  translateLang() {
    let filterDropDown = [];
    this.translateService.get(["ACITIVITY-FILTER_ARR"]).subscribe(
      values => {
        filterDropDown = Object.keys(values).map(key => values[key]);
        this.filterArr = filterDropDown[0];
      }
    );
    let errorCodeList = [];
    let tabsList = [];
    this.translateService.get(["ERROR_CODES"]).subscribe(
      values => {
        errorCodeList = Object.keys(values).map(key => values[key]);
        this.i18NerrorCodeList = errorCodeList[0];
      }
    );

    this.translateService.get(["SETTINGS"]).subscribe(
      values => {
        tabsList = Object.keys(values).map(key => values[key]);

        this.i18tabsList = tabsList[0].TABSDATA;
      }
    );

    let actionDropDown = [];
    this.translateService.get(["ACTION-VALUE_ARR"]).subscribe(
      values => {
        actionDropDown = Object.keys(values).map(key => values[key]);
        this.actionValue = actionDropDown[0];
      }
    );
    let constStrings = [];
    this.translateService.get(["ACTIVITYHISTORY"]).subscribe(
      values => {
        constStrings = Object.keys(values).map(key => values[key]);
        this.allUserStr = constStrings[0].ALLUSERS;
        this.allDeviceStr = constStrings[0].ALLDEVICES;
      }
    );
  }

  selectedLanguage: any;
  isShowFilter: any;
  disableFilter: boolean = false;
  curentUser: any
  ngOnInit() {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; // Fallback to UTC if not available
    this.grayfilter = true;
    this.filterClass = this.inActivefilter;
    this.getAllActivity();
    this.startMinDate();
    this.startDateMin();
    this.getToday();
    let selectedLangStringValue = localStorage.getItem("selectedLang");
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
    }

    this.translateService.use(this.selectedLanguage);
    this.translateLang();

    let logginUserStringValue = localStorage.getItem('currentUser');
    let currentUserData: any;

    if (logginUserStringValue) {
      currentUserData = JSON.parse(logginUserStringValue);
      this.curentUser = currentUserData;
    }
    if (currentUserData.roleType != 'MEMBERS') {
      this.getAllUser();
    }
    this.getUserDevicesInTree();
  }
  getStatus(val: string) {
    if (val === this.translateService.instant('STATUS.SUCCESS') || val === this.translateService.instant('STATUS.PARTIALLYSUCCESS')) {
      return "btn btnsuccess";
    } else if (val == this.translateService.instant('STATUS.PENDING')) {
      return "btn btnpending";
    } else {
      return "btn btnfailed";
    }
  }
  // auto select start date
  startDateMin() {
    let myCurrentDate = new Date();
    let myPastDate = new Date(myCurrentDate);
    myPastDate.setDate(myPastDate.getDate() - 6);
    let pastDate = this.DatePipe.transform(myPastDate, "yyyy-MM-dd");
    this.startDate = pastDate;
  }
  // disable start date before 30 days
  startMinDate() {
    let myCurrentDate = new Date();
    let myPastDate = new Date(myCurrentDate);
    myPastDate.setDate(myPastDate.getDate() - 30);
    let pastDate = this.DatePipe.transform(myPastDate, "yyyy-MM-dd");
    this.startMin = pastDate;
  }
  // To Get today
  getToday() {
    let ChangedFormat = this.DatePipe.transform(this.today, "yyyy-MM-dd");
    this.maxDate = ChangedFormat;
    this.endDate = this.maxDate;
  }
  defaultOrder: boolean = false;
  previousSort: string | undefined = 'DESC'
  previousfieldToSort: string | undefined = 'date'
  sortTable(column: string) {
    this.ActivityDto = new ActivityHistoryDto();
    this.defaultOrder = !this.defaultOrder;
    this.ActivityDto.fieldToSort = column;
    this.previousfieldToSort = column;
    this.ActivityDto.deviceId = this.deviceId;
    this.ActivityDto.userId = this.userId;
    this.ActivityDto.sort = this.defaultOrder ? 'ASC' : 'DESC';
    this.ActivityDto.field = column;
    this.ActivityDto.actionList = Array.from(this.actionListArr)
    this.ActivityDto.statusList = Array.from(this.statusListArr)
    this.previousSort = this.ActivityDto.sort;
    this.getAllActivity();
  }

  //krishna's code
  getAllActivity() {

    this.allActivity = [];
    try {
      this.isLoading = true;
      this.ActivityDto.fromDate = this.startDate;
      this.ActivityDto.toDate = this.endDate;
      this.ActivityDto.pageNumber = this.pageNumber = 0;
      this.ActivityDto.pageSize = this.pageSize;
      this._service.postService(this._service.API_URL.getAllActivityHistory, this.ActivityDto).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.defaultOrder = this.previousSort == 'ASC';
          this.allActivity = response.data;
          this.isLoading = false;
          this.totalItemsTemp = response.page.totalElements;
          this.currentPage = 1;
          if (this.totalItemsTemp < 10) {
            this.showPageList = false;
          } else {
            this.showPageList = true;
          }
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.isLoading = false;
    }
  }


  //  Fetching the User Information for the dropdown
  getAllUser() {
    try {
      this.userResponse = [];
      this.isLoading = true;
      this._service
        .getService(this._service.API_URL.getMyUsers)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.userResponse = response.data;
            this.userResponse.push({ "id": "", "name": this.allUserStr });
          }
        });

    } catch (error) { }
  }


  //  Fetching the User device Details here
  getUserDevicesInTree() {
    this.devicesList = [];
    let apiUrl: any;
    try {
      apiUrl = `${this._service.API_URL.getSystemMobileData}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      this._service.getService(apiUrl).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.devicesList = response.data;
          this.devicesList.push({ "id": "", "deviceName": this.allDeviceStr });
        }


      })
    } catch (error) {

    }

  }

  //  Fetching the Device Information for the dropdown
  userId: any

  getUserDevices(user: any) {
    this.isLoading = true;
    this.allActivity = []
    this.userId = user;
    try {
      if (!this.userId) {
        this.device = "";
        this.devicesList = [];
        this.getAllActivity();
        this.getUserDevicesInTree();
        this.isLoading = false;
      }
      this._service
        .getService(this._service.API_URL.getUserDeviceL + this.userId)
        .subscribe((response) => {
          if (response && response.status.code === 200) {

            this.devicesList = response.data.myDeviceList;
            this.devicesList.push({ "id": "", "deviceName": this.allDeviceStr });
            this.device = "";
            this.isLoading = false;

          }
        });


    } catch (error) {
      this.isLoading = false;
    }
    this.getAllActivityuser(user.id)
  }

  //  On Action Change of Checkbox changint the value
  actionChange(obj: any, event: any) {
    this.disableFilter = true;
    if (obj.value === "ALL") {
      if (obj.isChecked) {
        this.actionValue.filter((res: any) => {
          res.isChecked = true;
          this.actionListArr.add(res.value);
          this.filterCount();
        });
      } else if (!obj.isChecked) {
        this.actionValue.filter((res: any) => {
          res.isChecked = false;
          this.actionListArr = new Set();
          this.filterCount();
        });
      }
    }

    if (event.target.checked) {
      obj.isChecked = event.target.checked;
      this.actionListArr.add(obj.value);
      this.filterCount();
      if (this.actionListArr.size >= 2) {
        this.actionValue.filter((res: any) => {
          res.isChecked = true;
          this.actionListArr.add(res.value);
          this.filterCount();
        });
      }
    } else {
      this.actionListArr.delete(obj.value);
      this.filterCount();
      if (this.actionListArr.size <= 3) {
        this.actionValue.forEach((ele: any) => {
          if (ele.value === "ALL") {
            ele.isChecked = false;
            this.actionListArr.delete(ele.value);
            this.filterCount();
          }
        });
      }
    }
  }


  //  Counting the Selected checkbox count
  filterCount() {
    this.totalFIlterCount = Math.ceil(
      this.actionListArr.size + this.statusListArr.size
    );
    if (this.totalFIlterCount == 0) {
      this.totalFIlterCountVal = false;
      this.disableFilter = false;
    } else {
      this.totalFIlterCountVal = true;
    }
  }


  //  On Status Change of Checkbox changint the value
  statusChange(obj: any, event: any) {
    this.disableFilter = true;
    if (obj.value === "ALL") {
      if (obj.isChecked) {
        this.filterArr.filter((res: any) => {
          res.isChecked = true;
          this.statusListArr.add(res.value);
          this.filterCount();
        });
      } else if (!obj.isChecked) {
        this.filterArr.filter((res: any) => {
          res.isChecked = false;
          this.statusListArr = new Set();
          this.filterCount();
        });
      }
    }

    if (event.target.checked) {
      obj.isChecked = event.target.checked;
      this.statusListArr.add(obj.value);
      this.filterCount();
      if (this.statusListArr.size >= 7) {
        this.filterArr.filter((res: any) => {
          res.isChecked = true;
          this.statusListArr.add(res.value);
          this.filterCount();
        });
      }
    } else {
      this.statusListArr.delete(obj.value);
      this.filterCount();
      if (this.statusListArr.size <= 8) {
        this.filterArr.forEach((ele: any) => {
          if (ele.value === "ALL") {
            ele.isChecked = false;
            this.statusListArr.delete(ele.value);
            this.filterCount();
          }
        });
      }
    }
  }

  // To Set the min date for end date and start date
  setDate(date: any) {
    this.disableFilter = true;
    this.minDate = date;
    this.startDate = this.DatePipe.transform(date, "yyyy-MM-dd");
    this.grayfilter = false;
    this.whitefilter = true;
    this.filterClass = this.activeFilter;
  }
  EndDate(date: any) {
    this.disableFilter = true;
    this.grayfilter = false;
    this.whitefilter = true;
    this.filterClass = this.activeFilter;
    this.endDate = this.DatePipe.transform(date, "yyyy-MM-dd");
  }
  // FILTERS SELECTED BY THE USER
  Filter() {
    this.filterCount();
    this.disableFilter = false;
    this.isLoading = true;
    this.ActivityDto = new ActivityHistoryDto();
    this.ActivityDto.fieldToSort = this.previousfieldToSort;
    this.ActivityDto.sort = this.previousSort;
    this.ActivityDto.deviceId = this.deviceId;
    this.ActivityDto.actionList = Array.from(this.actionListArr);
    this.ActivityDto.statusList = Array.from(this.statusListArr);
    this.ActivityDto.fromDate = this.startDate;
    this.ActivityDto.toDate = this.endDate;
    this.ActivityDto.pageNumber = this.page = 0;
    this.ActivityDto.pageSize = this.pagelength;
    this._service
      .postService(
        this._service.API_URL.getAllActivityHistory,
        this.ActivityDto
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.defaultOrder = this.previousSort == 'ASC';
          this.allActivity = response.data;
          this.totalItemsTemp = response.page.totalElements;
          this.currentPage = 1;

          if (this.totalItemsTemp < 10) {
            this.showPageList = false;
          } else {
            this.showPageList = true;
          }
        }
      });
    this.showFilters();
    this.isLoading = false;
  }

  // TO GET THE DATA OF THE USER BASED ON THE USER AND DEVICE
  getAllActivityuser(event: any) {
    this.deviceId = event;

    try {
      this.isLoading = true;
      this.ActivityDto = new ActivityHistoryDto();
      this.ActivityDto.fieldToSort = this.previousfieldToSort;
      this.ActivityDto.sort = this.previousSort;
      if (this.userId && this.deviceId == 'undefined') {
        this.ActivityDto.userId = this.userId;
      } else {
        this.ActivityDto.deviceId = this.deviceId;
        this.ActivityDto.userId = this.userId;
      }
      this.ActivityDto.fromDate = this.startDate;
      this.ActivityDto.toDate = this.endDate;
      this.ActivityDto.actionList = Array.from(this.actionListArr);
      this.ActivityDto.statusList = Array.from(this.statusListArr);
      this.ActivityDto.pageNumber = this.pageNumber;
      this.ActivityDto.userId = this.userId;
      this.ActivityDto.pageSize = this.pageSize;
      this._service
        .postService(
          this._service.API_URL.getAllActivityHistory,
          this.ActivityDto
        )
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {

            this.isLoading = false;
            this.allActivity = response.data;
            this.myCount = response.page?.totalElements;
            this.totalItemsTemp = response.page.totalElements;
            this.totalItemsTemp = Math.ceil(
              (response.page.totalElements / this.pageSize) * 10
            );
            this.currentPage = 1
            if (this.totalItemsTemp < 10) {
              this.showPageList = false;
            } else {
              this.showPageList = true;
            }
          }
        });
    } catch (error) { }
  }

  // WHEN PAGE IS CHANGED IN THE PAGINATION
  pagechanged(page: any): void {
    this.ActivityDto.fieldToSort = this.previousfieldToSort;
    this.ActivityDto.sort = this.previousSort;
    if (page != 0) {
      this.page = page - 1;
    }
    this.isLoading = true;
    this.ActivityDto.pageNumber = this.page;
    this.ActivityDto.pageSize = this.pageSize;
    if (this.userId && this.deviceId == 'undefined') {
      this.ActivityDto.userId = this.userId;
    } else {
      this.ActivityDto.deviceId = this.deviceId;
      this.ActivityDto.userId = this.userId;
    }
    this.ActivityDto.fromDate = this.startDate;
    this.ActivityDto.toDate = this.endDate;

    if (this.ActivityDto.actionList != undefined || this.ActivityDto.statusList != undefined) {
      this.ActivityDto.actionList = Array.from(this.actionListArr);
      this.ActivityDto.statusList = Array.from(this.statusListArr);
    }
    this._service
      .postService(
        this._service.API_URL.getAllActivityHistory,
        this.ActivityDto
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.allActivity = response.data;
          this.totalItemsTemp = Math.ceil(
            (response.page.totalElements / this.pageSize) * 10
          );
          if (this.totalItemsTemp < 10) {
            this.showPageList = false;
          } else {
            this.showPageList = true;
          }
        }
      });

  }

  // TO SHOW AND HIDE THE FILTER POPUP
  showFilters() {
    this.isShowFilter = !this.isShowFilter;
    if (this.totalFIlterCountVal || this.isShowFilter) {
      this.grayfilter = false;
      this.whitefilter = true;
      this.filterClass = this.activeFilter;
    } else {
      this.grayfilter = true;
      this.whitefilter = false;
      this.filterClass = this.inActivefilter;
    }
  }
  // TO RESET THE FILTER POPUP
  reset() {
    this.disableFilter = false;
    this.isShowFilter = !this.isShowFilter;
    this.grayfilter = true;
    this.whitefilter = false;
    this.filterClass = this.inActivefilter;
    this.actionValue.filter((res: any) => {
      res.isChecked = false;
    });
    this.filterArr.filter((res: any) => {
      res.isChecked = false;
    });
    this.actionListArr = new Set();
    this.statusListArr = new Set();
    this.ActivityDto.actionList = [];
    this.ActivityDto.statusList = [];
    this.ActivityDto.pageNumber = 0;

    this.getAllActivity();
    this.filterCount();
    setTimeout(() => {
      this.startDateMin();
      this.startMinDate();
      this.getToday()
    }, 1000);
  }
  // SELETING THE PAGE SIZE
  pageSizeList(pagelength: any) {
    this.pagelength = pagelength;
    this.ActivityDto.fieldToSort = this.previousfieldToSort;
    this.ActivityDto.sort = this.previousSort;
    this.ActivityDto.pageSize = this.pageSize;
    this.ActivityDto.deviceId = this.deviceId;
    this.ActivityDto.actionList = Array.from(this.actionListArr);
    this.ActivityDto.statusList = Array.from(this.statusListArr);

    this._service
      .postService(
        this._service.API_URL.getAllActivityHistory,
        this.ActivityDto
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.allActivity = response.data;
          this.isLoading = false;

          this.totalItemsTemp = Math.ceil(
            (response.page.totalElements / pagelength) * 10
          );
          if (this.totalItemsTemp < 10) {
            this.showPageList = false;
          } else {
            this.showPageList = true;
          }
          this.currentPage = 1;
        }
        this.isLoading = false;
      });
  }


  closeModal() {
    $('#errCodeDescModal').modal('hide');
  }

  getErrorCodeType(desc: string) {

    if (desc != null) {
      let descArr = desc.split(",");

      if (parseInt(desc) || descArr?.length > 1 || desc.includes('entityInfo_') || desc.includes('EntityInfo_')) {

        return "SHOW DETAILS";
      }
    }
    return desc;
  }

  getErrorCodeDescription(desc: string, statusParam: string) {

    this.otherErrorCodes = [];
    if (desc.includes('entityInfo_') || desc.includes('EntityInfo_')) {

      this.getErrorCodeFromApi(desc.replace('entityInfo_', ''));
    } else {
      if (statusParam && statusParam != 'null' && statusParam != 'undefined') {
        this.otherErrorCodes = desc
          .split(",")
          .map(code => code.trim())
          .filter(code => code)
          .map(code => `${code} - ${statusParam}`);
      } else {
        this.otherErrorCodes = desc.split(",");
      }

    }

    $('#errCodeDescModal').modal('show');
  }

  getI18nAsErrorCode(errorCode: string): string {
    let [code, appName] = errorCode.split("-").map(part => part.trim());
    appName = appName || '';

    const template = this.i18NerrorCodeList[code] || code;
    if (code === '302') {
      return template.replace('{{appName}}', appName);
    }
    return template;
  }

  getErrorCodeFromApi(entityInfoId: string) {
    this.isLoading = true;
    this.errorCodeReponse = [];
    this._service
      .getService(
        this._service.API_URL.getErrorCodeData + entityInfoId
      )
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          let codeResponse = null;
          if (response.data.errorCodes) {
            codeResponse = JSON.parse(response.data.errorCodes);
          }

          let antitheftType = null;
          let prntlType = null;
          let scanType = null;
          let sfType = null;
          let changePinType = null;
          let youtubeType = null;
          let screenTimeType = null;
          let antiSpyWare = null;

          this.i18tabsList.forEach((tab: any) => {
            if (tab.key == 'ANTITHEFT') {
              antitheftType = tab.tabsName;
            } else if (tab.key == 'PARENTALCONTROL') {
              prntlType = tab.tabsName;
            } else if (tab.key == 'SCAN') {
              scanType = tab.tabsName;
            } else if (tab.key == 'ONLINESAFETY' || tab.key == 'PRIVACY' || tab.key == 'OPTIMIZATION') {
              sfType = "Optimization-Privacy-Online Safety";
            } else if (tab.key == 'CHANGEPIN') {
              changePinType = tab.tabsName;
            }
            else if (tab.key == 'YOUTUBE') {
              youtubeType = tab.tabsName;
            }
            else if (tab.key == 'SCREENTIME') {
              screenTimeType = tab.tabsName;
            }
            else if (tab.key == 'ANTISPYWARE_SETTING') {
              antiSpyWare = tab.tabsName;
            }
          })


          if (codeResponse.antiTheftSettings) {

            let obj = {
              "type": antitheftType,
              "errorCodes": codeResponse.antiTheftSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }
          if (codeResponse.prntlCtrlSettings) {

            let obj = {
              "type": prntlType,
              "errorCodes": codeResponse.prntlCtrlSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }
          if (codeResponse.scanSettings) {

            let obj = {
              "type": scanType,
              "errorCodes": codeResponse.scanSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }
          if (codeResponse.sfSettings) {

            let obj = {
              "type": sfType,
              "errorCodes": codeResponse.sfSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }

          if (codeResponse.pinSettings) {

            let obj = {
              "type": changePinType,
              "errorCodes": codeResponse.pinSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }

          if (codeResponse.youtubeSettings) {

            let obj = {
              "type": youtubeType,
              "errorCodes": codeResponse.youtubeSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }

          if (codeResponse.screenTimeSettings) {

            let obj = {
              "type": screenTimeType,
              "errorCodes": codeResponse.screenTimeSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }

          if (codeResponse.antiSpyWareSettings) {

            let obj = {
              "type": antiSpyWare,
              "errorCodes": codeResponse.antiSpyWareSettings.errorCode.split(",")
            }
            this.errorCodeReponse.push(obj);
          }
          console.log(this.errorCodeReponse);

        }
      });
  }

  getname(val: any) {
    let l = val.split('')?.length;
    let final = '';
    if (l > 10) {
      let a = val.split('');
      for (let i = 0; i < 10; i++) {
        final = final + a[i];
      }
      final = final + '...'
    } else {
      final = val
    }
    return final;
  }
}
